import en from "./staff-pay.en.json";
import ar from "./staff-pay.ar.json";
import { staffText } from "@/lib/staff-language";
import { type PayRecord } from "./use-staff-pay";

export const payText=(key:keyof typeof en,rtl:boolean)=>(rtl?ar:en)[key];
export const payProofLabel=(record:PayRecord,rtl:boolean)=>staffText(record.proofType==="photo"?"Signed slip photo":`Confirmed by ${(rtl&&record.employeeNameAr?record.employeeNameAr:record.employeeName).split(" ")[0]} (ID digits)`,rtl);
